(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/ui/form/assets/javascripts/components/checkbox-group.trinidad.js') >= 0) return;  svs.modules.push('/components/ui/form/assets/javascripts/components/checkbox-group.trinidad.js');
"use strict";

(() => {
  "use strict";

  var __webpack_require__ = {};
  (() => {
__webpack_require__.n = module => {
var getter = module && module.__esModule ? () => module['default'] : () => module;
      __webpack_require__.d(getter, {
        a: getter
      });
      return getter;
    };
  })();
  (() => {
__webpack_require__.d = (exports, definition) => {
for (var key in definition) {
if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
Object.defineProperty(exports, key, {
            enumerable: true,
            get: definition[key]
          });
        }
      }
    };
  })();
  (() => {
__webpack_require__.o = (obj, prop) => Object.prototype.hasOwnProperty.call(obj, prop);
  })();
  var __webpack_exports__ = {};

  __webpack_require__.d(__webpack_exports__, {
    "default": () => (checkbox_group)
  });
  ; 
  const external_PropTypes_namespaceObject = window["PropTypes"];
  var external_PropTypes_default = __webpack_require__.n(external_PropTypes_namespaceObject);
  ; 

  function CheckboxGroup(_ref) {
    let className = _ref.className,
      inline = _ref.inline,
      minWidth = _ref.minWidth,
      id = _ref.id,
      thin = _ref.thin,
      children = _ref.children;
    const classes = ['form-toggle-group'];
    if (className) {
      classes.push(className);
    }
    if (inline) {
      classes.push('form-toggle-inline');
    }
    if (thin) {
      classes.push('form-toggle-thin');
    }
    return React.createElement("div", {
      className: classes.join(' '),
      id: id,
      style: minWidth && {
        'min-width': minWidth
      }
    }, children);
  }
  CheckboxGroup.__docgenInfo = {
    "description": "",
    "methods": [],
    "displayName": "CheckboxGroup",
    "props": {
      "children": {
        "description": "",
        "type": {
          "name": "node"
        },
        "required": false
      },
      "className": {
        "description": "",
        "type": {
          "name": "string"
        },
        "required": false
      },
      "id": {
        "description": "",
        "type": {
          "name": "string"
        },
        "required": false
      },
      "inline": {
        "description": "",
        "type": {
          "name": "bool"
        },
        "required": false
      },
      "minWidth": {
        "description": "",
        "type": {
          "name": "string"
        },
        "required": false
      },
      "thin": {
        "description": "",
        "type": {
          "name": "bool"
        },
        "required": false
      }
    }
  };
  const checkbox_group = CheckboxGroup;
  (((window.svs = window.svs || {}).ui = window.svs.ui || {}).ReactForm = window.svs.ui.ReactForm || {}).CheckboxGroup = __webpack_exports__["default"];
})();

 })(window);